import styled from 'styled-components/native'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons'

import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import Typography from 'APP/Converse/Typography'

export const CardContainer = styled.View<{ isSmall?: boolean }>`
  padding: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  ${({ isSmall }) =>
    isSmall &&
    `
      flex-basis: 50%;
      align-self: stretch;
    `}
`

export const Card = styled(DialogueTouchableOpacity)`
  flex: 1 1 0%;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  ${({ theme }) => theme.shadows.normal}
`

export const CardImage = styled.Image`
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  aspect-ratio: 2;
`

export const TagListContainer = styled.View`
  flex: 1 1 0%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 0.8}px;
  margin-top: ${({ theme }) => theme.metrics.baseMargin * -1}px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin * -0.3}px;
`

export const TagContainer = styled.View`
  flex-direction: row;
  align-items: center;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const TagCopy = styled(Typography)`
  text-transform: uppercase;
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
  color: ${({ theme }) => theme.colors.background};
`

export const DescriptionContainer = styled.View`
  flex: 1 1 0%;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const Title = styled(Typography)`
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.3}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const DetailsContainer = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const DetailsItemContainer = styled.View`
  flex-grow: 1;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
`

export const DetailLabel = styled(Typography)`
  flex-shrink: 1;
`

export const CountdownIcon = styled(MaterialIcon)`
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const RankIcon = styled(MaterialCommunityIcon)`
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 0.3}px;
`

export const TotalValueContainer = styled.View`
  flex: 1 1 0%;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  border-top-width: 1px;
  border-color: ${({ theme }) => theme.colors.elementsBorder};
`
